export enum Source {
  File = 'File',
  Card = 'Card',
  Spreadsheet = 'Spreadsheet',
}
